<template>
  <div @click="$emit('increment-stage', item.name)" class="hotkey-item" :class="stageClass">
    <div :class="">{{ item.name }}</div>
    <div class="hotkey">
      <div v-for="hotkey in item.hotkeys">{{ hotkey }}</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "HotkeyItem",
    props: ['item', 'stage'],
    computed: {
      stageClass() {
        return `stage-${this.stage}${this.item.featured ? ' featured' : ''}`;
      }
    }
  }
</script>

<style lang="scss">

  .hotkey-item {
    padding: 4px 12px 4px 6px;
    display: flex;
    justify-content: space-between;
    border-left: 6px solid transparent;
  }

  .hotkey-item + .hotkey-item {
    margin-top: 8px;
  }

  .hotkey-item:hover {
    background-color: hsl(204, 20%, 89%);
    cursor: pointer;
  }

  .featured {
    background-color: hsl(204, 70%, 96%);
  }

  .stage-1 {
    border-left: 6px solid hsl(204, 20%, 80%);
  }

  .stage-2 {
    border-left: 6px solid hsl(204, 100%, 45%);
  }

  .hotkey {
    font-weight: bold;
    color: hsl(204, 50%, 30%);
    text-align: end;
  }
</style>